'use client'

import { useEffect, useState } from 'react'
import { persistor } from 'features/store'

// Tracks whether redux-persist has finished reading auth state back out of
// localStorage. Needed because ReduxProvider no longer blocks rendering on
// this (see features/provider.tsx) — anything that treats an empty/default
// auth state as "logged out" must wait for this to be true first, or it
// will misfire during the brief window before rehydration completes.
export function usePersistBootstrapped() {
  const [bootstrapped, setBootstrapped] = useState(() => persistor.getState().bootstrapped)

  useEffect(() => {
    if (bootstrapped) return
    const unsubscribe = persistor.subscribe(() => {
      if (persistor.getState().bootstrapped) {
        setBootstrapped(true)
      }
    })
    return unsubscribe
  }, [bootstrapped])

  return bootstrapped
}
